import React from 'react'
import {toast} from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import {add, remove} from '../redux/slices/CartSlice'

//This component is for showing a product on Home page
export default function Product({post}) {
    
    const cart = useSelector((state)=> state.cart);
    const dispatch = useDispatch();

    const addToCart = () =>{
      dispatch(add(post));
      toast.success('Item added to Cart');
    }

    const removeFromCart = () =>{
      dispatch(remove(post.id));
      toast.error('Item removed from Cart');
    }

  return (
    <div className='flex flex-col items-center justify-between xl:hover:scale-110 transition duration-300 ease-in xl:hover:shadow-[rgba(0,_0,_0,_0.4)_0px_30px_90px] gap-3 p-4 mt-10 ml-5 rounded-xl'>
      <div>
        <p className='text-gray-700 font-semibold text-lg text-left truncate w-40 mt-1'>{post.title}</p>
      </div>
      <div>
        <p className='w-50 text-gray-400 font-normal text-[14px] text-left'>{post.description.split(" ").slice(0,10).join(" ") + "..."}</p>
      </div>
      <div className='h-[180px]'>
        <img src={post.image} alt="Error Loading Img" className='h-full w-full'/>
      </div>
      <div className='flex justify-between gap-15 items-center w-full mt-5'>
        <div>
          <p className='text-green-600 font-semibold'>${post.price}</p>
        </div>
        <div className='text-gray-700 border-2 border-gray-700 rounded-full font-semibold text-[12px] p-1 px-3 uppercase hover:bg-gray-700 hover:text-white transition duration-300 ease-in'>
            {
                cart.some((p)=> p.id === post.id) ? 
                (<button
                  onClick={removeFromCart}>
                  Remove Item</button>) : 
                (<button
                  onClick={addToCart}>
                  Add to Cart</button>)
            }
        </div>
      </div>
    </div>
  )
}
